import type { Underlying } from 'models/underlying';

export function getUnderlyingsIndexableCodes(underlyings: ReadonlyArray<Underlying> = []): string[] {
  return underlyings?.reduce<string[]>((codes, underlying) => {
    switch (underlying.asset) {
      case 'Equity':
      case 'Commodity':
      case 'Rate':
        {
          codes.push(underlying.bloombergTickerCode);
          if (underlying.reutersCode) {
            codes.push(underlying.reutersCode);
          }
        }
        break;
    }
    codes.push(underlying.id);
    return codes;
  }, []);
}
